import FileUploadDispatcherFactory from './FileUploadDispatcherFactory';
import { IFileUploadDispatcherFactoryMethod as IFileUploadDispatcherFactory } from './interfaces';
import { DIUploadTypes } from '../types';

export const { FileUploadDispatcher } = DIUploadTypes;

export type { IFileUploadDispatcherFactory };

export default FileUploadDispatcherFactory;
